import { defineComponent } from 'vue';
import Name from '@/presentation/components/campaign-settings/name/name.vue';
import Duration from '@/presentation/components/campaign-settings/duration/duration.vue';
import DeliveryMode from '@/presentation/components/campaign-settings/delivery-mode/delivery-mode.vue';
import BudgetWrapper from '@/presentation/components/campaign-settings/budget-wrapper/budget-wrapper.vue';
import CampaignSettingsCheckboxes from '@/presentation/components/campaign-settings/campaign-settings-checkboxes/campaign-settings-checkboxes.vue';
import PartnershipType from '@/presentation/components/campaign-settings/partnership-type/partnership-type.vue';
import CampaignType from '@/presentation/components/campaign-settings/campaign-type/campaign-type.vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import CampaignSettingsCode from '@/presentation/components/campaign-settings/campaign-settings.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		Name,
		Duration,
		DeliveryMode,
		BudgetWrapper,
		CampaignSettingsCheckboxes,
		PartnershipType,
		CampaignType
	},
	setup: () => {
		const code = new CampaignSettingsCode();
		return {
			isLoading: code.isLoading
		};
	}
});
